// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorMessageFromUnknownErrorType = (error: any) => {
  let errorMessage = "";
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  } else {
    errorMessage = "An unknown error occurred. Please try again.";
  }
  return errorMessage;
};
